import React from 'react';
import { Route, Switch} from 'react-router-dom';
import Home from './home/index.js'
import Photo from './photo'
import './App.css';
import 'antd-mobile/dist/antd-mobile.css'

function App() {
  return (
    <div className="App">
      <Switch>
        {/* <Route exact path='/' component={Home}/> */}
        {/* 登录 */}
        <Route exact path='/user/user-gallery' component={Home}/>
        {/* 不登录 */}
        <Route exact path='/user/order-gallery' component={Photo}/>
      </Switch>      
    </div>
  );
}

export default App;
